var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 13.2334L10.975 10.0001L7.74164 6.76674C7.66449 6.68959 7.60329 6.598 7.56154 6.49719C7.51978 6.39639 7.49829 6.28835 7.49829 6.17924C7.49829 6.07013 7.51978 5.96209 7.56154 5.86129C7.60329 5.76048 7.66449 5.66889 7.74164 5.59174C7.81879 5.51459 7.91039 5.45339 8.01119 5.41163C8.11199 5.36988 8.22003 5.34839 8.32914 5.34839C8.43825 5.34839 8.54629 5.36988 8.64709 5.41163C8.7479 5.45339 8.83949 5.51459 8.91664 5.59174L12.7416 9.41674C13.0666 9.74174 13.0666 10.2667 12.7416 10.5917L8.91664 14.4167C8.83955 14.494 8.74797 14.5553 8.64716 14.5971C8.54635 14.6389 8.43828 14.6604 8.32914 14.6604C8.22 14.6604 8.11193 14.6389 8.01112 14.5971C7.91031 14.5553 7.81874 14.494 7.74164 14.4167C7.42498 14.0917 7.41664 13.5584 7.74164 13.2334Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.dd2e6017a768ff8415fcb66b530e98a3.svg";
export { ForwardRef as ReactComponent };